module.exports = __webpack_public_path__ + "static/media/PL.27ff4166.svg";